import { createSelector } from 'reselect';

import { UserPermission } from 'shared/types/user';

import { RootState } from '../../index';

import { RawUser } from './types';

export const isUserAuthorized = (state: RootState) => state.user.isUserAuthorized;
export const getUserProfile = (state: RootState) => state.user.profile;
export const getThemeMode = (state: RootState) => state.user.themeMode;
export const sourceMappings = (state: RootState) => state.user.sourceMappings;

export const userEmail = createSelector(
  getUserProfile,
  (user: RawUser | null) => user ? user.email : '',
);

export const getUserPermissions = createSelector(
  getUserProfile,
  (userProfile) => userProfile.role.permissions || [],
);

export const canUserManageWorkflows = createSelector(
  getUserPermissions,
  (permissions) => permissions.some((permission: string) => (
    permission === UserPermission.MANAGE_WORKFLOWS_PERMISSION
  )),
);

export const canUserManageSafelists = createSelector(
  getUserPermissions,
  (permissions) => permissions.some((permission: string) => (
    permission === UserPermission.MANAGE_SAFELISTS_PERMISSION)
  ),
);

export const getUserPreferences = createSelector(
  getUserProfile,
  (profile) => profile.preferences || {},
);
